import { preprocessBullets } from './preprocessBullets';
import { preprocessFilePaths } from './preprocessFilePaths';

/**
 * Unified content preprocessing for markdown content.
 * Handles all text transformations that need to happen before markdown parsing.
 * Optimized for performance with early returns.
 */
export function preprocessContent(content: string): string {
  // Quick check - if empty content, return as-is
  if (!content || content.length === 0) {
    return content;
  }

  let processed = content;

  if (content.includes('/References/') || content.includes('circuit://')) {
    processed = preprocessFilePaths(processed);
  }

  if (content.includes('•')) {
    processed = preprocessBullets(processed);
  }

  return processed;
}
